export default __webpack_public_path__ + "static/media/a3.689c5986.jpg";